import { render, staticRenderFns } from "./CartProductItem.vue?vue&type=template&id=18645d7c&scoped=true"
import script from "./CartProductItem.vue?vue&type=script&lang=js"
export * from "./CartProductItem.vue?vue&type=script&lang=js"
import style0 from "./CartProductItem.vue?vue&type=style&index=0&id=18645d7c&prod&lang=scss"
import style1 from "./CartProductItem.vue?vue&type=style&index=1&id=18645d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18645d7c",
  null
  
)

export default component.exports